<template lang="pug">
  ul
    Tree(:model="children")
</template>

<script>
import Core from '@/service/apis/Core'
import Tree from '@/components/common/Tree'

export default {
  created() {
    const that = this
    Core.listContinents()
      .then((r) => {
        this.children = r.data.content.map((c) => {
          const loc = {
            id: c.id,
            name: c.name,
            coordinates: c.coordinates,
            type: 'CONTINENT',
            isLoading: false,
            select() {
              that.select(loc)
            },
            expander() {
              that.expander(c.id, loc)
            },
            children: []
          }
          return loc
        })
      })
      .catch((e) => {
        this.$emit('error', e)
      })
  },
  data: () => ({
    children: []
  }),
  methods: {
    select(l) {
      this.$emit('input', l)
    },
    expander(id, p) {
      const parent = p
      const that = this
      if (parent.children.length === 0) {
        parent.isLoading = true
        Core.listChildLocations(id)
          .then((locations) => {
            parent.isLoading = false
            if (locations.data.content.length === 0) {
              parent.expander = null
            }
            parent.children.push(locations.data.content.map((l) => {
              const loc = {
                id: l.id,
                name: l.name,
                country: l.country,
                coordinates: l.coordinates,
                children: [],
                isLoading: false,
                select() {
                  that.select(loc)
                },
                expander() {
                  loc.isLoading = false
                  that.expander(l.id, loc)
                }
              }

              return loc
            }))
          })
          .catch((e) => {
            this.$emit('error', e)
            parent.isLoading = false
          })
      }
    }
  },
  components: {
    Tree
  }
}
</script>



// WEBPACK FOOTER //
// src/components/common/LocationsTree.vue